import { Padrao } from '../generic/padrao';

export class AdendoPecasConstituicao extends Padrao{

    override idTab = 260;

    nome: string;
    ativo: string;
}
